<template>
  <li
    data-sidebar="menu-sub-item"
    class="list-none relative ltr:pl-0 rtl:pr-0 rtl:mr-0 ltr:ml-0 py-1 sidebar-sub-item"
  >
    <slot />
  </li>
</template>

<style scoped>
.sidebar-sub-item::before {
  content: '';
  position: absolute;
  width: 4px;
  height: 0;
  left: calc(-0.5rem - 1px);
  top: 50%;
  transform: translateY(-50%);
  background-color: var(--sidebar-indicator);
  border-radius: 2px;
  transition: height 0.2s ease-out;
}

.sidebar-sub-item:has([data-active='true'])::before,
.sidebar-sub-item:has(.active)::before {
  height: 70%;
  top: 50%;
  transform: translateY(-50%);
}

/* RTL support */
#app[dir='rtl'] .sidebar-sub-item::before {
  left: auto;
  right: -0.5rem;
}
</style>
